<template>
  <div class="col-12 col-md order-1 order-md-0">
    <div
      class="text-azul-medio text-uppercase gilmer h4 text-center mt-5 mt-md-3 font-weight-light"
    >
      Acerca del proceso
    </div>
    <div class="bg-azul-claro py-4 px-4 h6 text-center rounded">
      Los resultados del proceso de listas de espera de Admisión Escolar estarán
      disponibles en este portal desde el
      <strong>{{ fechaListaEspera }}</strong>
      <img
        src="https://cdnsaemineduc.s3.us-east-1.amazonaws.com/img/fechas.svg"
        width="260"
        class="img-fluid my-4"
        alt
      />

      <div class="bg-azul-medio rounded py-4 text-white gilmer mx-0 mx-lg-3">
        Accede con el mismo
        <br />
        <strong>USUARIO</strong> y
        <strong>CONTRASEÑA</strong>
        <br />del proceso de postulación
      </div>
    </div>
    <div class="bg-azul-claro py-3 px-4 h6 text-center rounded mt-5 mt-lg-3">
      <a
        :href="ayuda"
        data-testid="enlace-ayuda-mineduc"
        target="_blank"
        class="gilmer h5 font-weight-light"
      >
        <strong class="d-inline-block">¿Dudas con tus resultados?</strong>
        <span
          class="d-inline-block mt-2 text-uppercase font-weight-bold subrayado h6"
          >Consulta Ayuda Mineduc</span
        >
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: "InformacionResultados",
  data() {
    return {
      ayuda: PLATAFORMA.AYUDA_RESULTADOS,
      fechaListaEspera: ""
    };
  },
  created() {
    const obtenerValorLocalStorage = (key, valorPorDefecto = "----") => {
      const valor = localStorage.getItem(key);
      return valor ? valor : valorPorDefecto;
    };

    this.fechaListaEspera = obtenerValorLocalStorage("fechaListaEspera");
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/login/InformacionResultados.vue